import downloadFileFromDatalake from '@/utils/downloadFileFromDatalake';
import { triggerBlobDownload } from '@/utils/triggerBlobDownload';

const downloadFile = async (fileId: string, fileName: string, maxRetries = 3) => {
  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    try {
      const fileResponse = await downloadFileFromDatalake(fileId);
      triggerBlobDownload(fileResponse.data, fileName);
      return;
    } catch (error) {
      console.error('Error downloading file:', error);
      if (attempt < maxRetries)
        await new Promise<void>(resolve => {
          setTimeout(resolve, 500);
        });
    }
  }
};

export default downloadFile;
